import script from "./my.vue?vue&type=script&setup=true&lang=ts"
export * from "./my.vue?vue&type=script&setup=true&lang=ts"

import "./my.vue?vue&type=style&index=0&id=e3c5d39c&lang=scss&scoped=true"

import exportComponent from "D:\\code\\idea2023\\dmMes\\h5_standard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3c5d39c"]])

export default __exports__